import { isMobile } from '@/shared/util/device';

import Cookies from 'js-cookie';

const defaultOptions = {
  domain: CONFIG.COOKIE_DOMAIN,
  expires: 1,
};

interface PasswordUpdateCookie {
  route: string;
  success: boolean;
}
const getPasswordChangeCookie = (): PasswordUpdateCookie | false => {
  try {
    return JSON.parse(<string>Cookies.get('passwordUpdate')) || false;
  } catch (_e) {
    return false;
  }
};

/**
 * Determines the appropriate redirect route after password change/set
 * For mobile web signups, redirect to the mobile finish setup page
 */
const getRedirectRoute = (loginId: number | null): string => {
  // If changing existing password, go to profile
  if (loginId) {
    return '/profile';
  }

  // For new signups, check if mobile
  const isOnMobileDevice = isMobile();
  if (isOnMobileDevice) {
    return '/onboarding/mobile-finish-setup?mobile=1';
  }

  // Default for desktop signups
  return '/';
};

/**
 * Starts a password change request using the new login flow, will default to redirecting to the login page if the
 * redirect param is not set to false
 * @param loginId - The user id of the user to change the password for if available
 * @param redirect - Whether or not to redirect to the login page
 */
const startPasswordChange = (loginId: number | null = null, redirect = true) => {
  const route = getRedirectRoute(loginId);

  Cookies.set(
    'passwordUpdate',
    JSON.stringify({
      route,
      success: false,
    } as PasswordUpdateCookie),
    { ...defaultOptions },
  );

  if (redirect) {
    const action = loginId ? 'change' : 'set';
    return window.location.assign(`${CONFIG.LOGIN_FRONTEND_ROOT}/password/${action}`);
  }
};

/**
 * @return {Boolean}
 */
const passwordChangeSuccessful = (clear = true): boolean => {
  const passwordChangeCookie = getPasswordChangeCookie();
  // biome-ignore lint/complexity/useOptionalChain: Possibly false
  const success = passwordChangeCookie && passwordChangeCookie.success;
  if (success && clear) {
    clearPasswordChangeCookie();
  }
  return success;
};

const clearPasswordChangeCookie = (): void => {
  Cookies.remove('passwordUpdate', { ...defaultOptions });
};

export default {
  startPasswordChange,
  passwordChangeSuccessful,
  clearPasswordChangeCookie,
};
